import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { SectionAccessState } from './types';
import { SectionAccessQueryParams, SectionAccessResource } from '@/api/requests/types';
import moment from 'moment';

export const getters: GetterTree<SectionAccessState, RootState> = {

    /**
     * Check if section access module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    sectionAccessModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('sectionAccesses');
    },

    /**
     * Check if can view every section access.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnySectionAccesses: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('sectionAccesses.viewAny');
    },

    /**
     * Check if can view section access.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewSectionAccesses: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('sectionAccesses.view');
    },

    /**
     * Get date until access is valid.
     * @param state
     */
    getLastSectionAccessValidity: (state) => (userId: number, section: string): Date => {
        let lastAccess = state.sectionAccesses.filter((sectionAccess) => sectionAccess.section === section && sectionAccess.user.id === userId)
                                            .sort((a, b) => {return a.loggedInAt > b.loggedInAt ? -1 : 1})[0];

        return !!lastAccess ? moment(lastAccess.loggedInAt).add(10,'minutes').toDate() : new Date('2000-01-01 00:00:00');
    },

    /**
     * Check if can create section access.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateSectionAccesses: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('sectionAccesses.create');
    },

    /**
     * Get http filters.
     *
     * @param state
     */
    httpFilters: (state): SectionAccessQueryParams => ({
        ...state.filters,
    }),




};
